// extracted by mini-css-extract-plugin
export default {"pageHeader":"styles_pageHeader__mAQio","line":"styles_line__fjyrj","text":"styles_text__HC-8a"};